import script from "./UserWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./UserWidget.vue?vue&type=script&setup=true&lang=js"

import "./UserWidget.vue?vue&type=style&index=0&id=4ccee850&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ccee850"]])

export default __exports__